import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { getProfileRoutes } from '@client/pages/profilePage/routesProfile';
import { selectUserPermissions } from '@client/redux/user/userReducer';
import MenuDrawerItem from './menuDrawerItem/MenuDrawerItem';
import styles from './sideBarMenu.scss';

const SideBarMenu = ({ pathname, userPermissions }) => {
  const restrictions = Map({
    shouldBeLoggedIn: true,
    permissions: userPermissions,
  });

  const sideBarRoutes = getProfileRoutes(restrictions);

  return (
    <div className={styles.sideBarMenu}>
      <div className={styles.header}>
        {pathname ? pathname.replace(sideBarRoutes.ACCOUNT.TO, '') : '/'}
      </div>
      <nav className={styles.menu}>
        {Object.values(sideBarRoutes.ACCOUNT.ROUTES).map((route, index) => {
          return (
            <MenuDrawerItem
              containerClassName={styles.drawerItem}
              linkClassName={styles.drawerLink}
              subLinkClassName={styles.DrawerSubLink}
              route={route}
              index={index}
              key={`SideBarMenu:${route.LABEL}-${route.TO}`}
              alwaysShowSubRoutes={true}
            />
          );
        })}
      </nav>
    </div>
  );
};

SideBarMenu.propTypes = {
  pathname: PropTypes.string,
  userPermissions: ImmutablePropTypes.list,
};

function mapStateToProps(state) {
  return {
    userPermissions: selectUserPermissions(state),
  };
}
export default connect(mapStateToProps)(SideBarMenu);
